import type { GetStaticProps, InferGetStaticPropsType } from "next";
import { getAllPosts } from "@/lib/ghost";
import { HeroSection } from "@/components/shared/HeroSection";
import Footer from "@/components/shared/Footer";
import { BlogSeo } from "@/components/blog/BlogSeo";
import BlogPostCard from "@/components/blog/blogPostCard";

export const getStaticProps = (async () => {
  const posts = await getAllPosts();

  return {
    props: { posts },
    revalidate: 86400, // daily
  };
}) satisfies GetStaticProps;

export default function BlogPage({ posts }: InferGetStaticPropsType<typeof getStaticProps>) {
  return (
    <>
      <BlogSeo />
      <HeroSection
        heading="Blogs & Insights"
        body={
          <p className="text-balance text-center text-lg text-[#868C98]/90 lg:text-lg">
            Discover quick tips and how-tos to elevate your skills to the next level.
          </p>
        }
      />
      {!posts?.length ? (
        <div className="mx-auto w-full px-5 pt-[60px]">
          <main className="mb-10 flex flex-wrap justify-between gap-8 pt-5">
            <section className="w-full">
              <div className="gap-2 text-center text-[28px] font-semibold md:text-[32px]">
                Hmm, no blog posts could be found. Try again later.
              </div>
            </section>
          </main>
        </div>
      ) : (
        <div className="mx-auto max-w-screen-lg px-6 pb-6 transition-all duration-300 ease-in-out">
          <div className="mx-auto mt-16 grid max-w-2xl auto-rows-fr grid-cols-1 gap-5 md:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3">
            {posts.map((post) => {
              return <BlogPostCard key={post.slug} post={post} />;
            })}
          </div>
        </div>
      )}
      <Footer />
    </>
  );
}
